import { render } from "./CadastroPJ_Passo_1.vue?vue&type=template&id=5fe7c9c7&scoped=true"
import script from "./CadastroPJ_Passo_1.vue?vue&type=script&lang=js"
export * from "./CadastroPJ_Passo_1.vue?vue&type=script&lang=js"

import "./CadastroPJ_Passo_1.vue?vue&type=style&index=0&id=5fe7c9c7&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5fe7c9c7"]])

export default __exports__